import { getIso8601WithoutMilliseconds } from './device-config'

export const getTodayDateObject = (): Date => {
  return new Date()
}

export const formatDate = (date: number | string | Date): string => {
  const d = new Date(date)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const getQueryExpression = (start: string, end: string): string => {
  const startQuery = getStartQuery(start)
  const endQuery = getEndQuery(end)
  const and = start && end ? '&' : ''
  return `${startQuery}${and}${endQuery}`
}

const getStartQuery = (start: string): string => {
  const date = getIso8601WithoutMilliseconds(new Date(start))
  return start ? `start=${date}` : ''
}

const getEndQuery = (end: string): string => {
  const date = getIso8601WithoutMilliseconds(new Date(end))
  return end ? `end=${date}` : ''
}
